import api from '@/js/services/api';
export default {

    changeApplicantsStatus(shift_id, applicant_id, status) {
        return api().put(`/master-admin/shift-board/candidate/status/${shift_id}/update`, {applicant_id, status})
    },
    deleteShift(id) {
        return api().delete(`/master-admin/shift-board/` + id + `/delete`);
    },

    getShiftsInfo(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/master-admin/shift-board/get?' + searchParams.toString())
    },

    saveNewShift(form) {
        return api().post(`/master-admin/shift-board/create`, { form })
    },

    updateStatus(id) {
        return api().put(`/master-admin/shift-board/${id}/status/update`)
    },

    updateShift(id, shift) {
        return api().put(`/master-admin/shift-board/${id}/update`, {shift})
    },

    //employee

    getListOfShifts(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/applicant/shift-board/get?' + searchParams.toString())
    },

    unsubscribeFromShiftBoard(applicantId,shiftId ) {
        return api().put(`/applicant/${applicantId}/shift-board/${shiftId}/not-interested`)
    },

    subscribeToShiftBoard(applicantId, shiftId) {
        return api().put(`/applicant/${applicantId}/shift-board/${shiftId}/interested`)
    },





}
